<section>
  <gen-dynamic-form
    [formData]="formData"
    [formName]="formName"
    [formVertical]="true"
    (validateChange)="updateValidate($event)"
    (formChange)="updateForm($event.form)"
    [listenToDataChange]="true"
    [submitted]="submitted"
    [popupMode]="true"
    [valid]="isValid">   
  </gen-dynamic-form> 
</section>
<gen-overlay-loader class = "popup_action_loaded_position" [showOverlay]="true" *ngIf="updating"></gen-overlay-loader>